import {
  getAllUsersApi,
  getTraineesForGuardianApi,
  getUserDetailsApi,
} from "@/app/services/users.service";
import { UserDetailsModel } from "@/app/lib/models/UserDetailsModel";
import { AppConstants } from "@/app/lib/util/AppConstants";
import {
  HttpStatus,
  ResponseFormatModel,
} from "@/app/lib/models/ResponseFormatModel";
import { ChatSessionsModel } from "@/app/lib/models/ChatSessionsModel";
import { getTimeForChat } from "@/app/services/chats.service";
import logger from "@/lib/logger";

export const fetchAllGuardians = async (
  email: string,
  setGuardiansListAtom?: (value: Map<string, UserDetailsModel>) => void,
  sessionId?: string,
): Promise<UserDetailsModel[] | undefined> => {
  let allGuardiansList: UserDetailsModel[] = [];
  let guardiansMap = new Map<string, UserDetailsModel>();
  try {
    const response = await getAllUsersApi(
      AppConstants.Roles.GUARDIAN,
      email,
      sessionId,
    );
    if (response && response.data && response.status === HttpStatus.OK) {
      allGuardiansList = response.data as UserDetailsModel[];
      if (allGuardiansList && allGuardiansList.length > 0) {
        allGuardiansList.map((user: UserDetailsModel) => {
          guardiansMap.set(user.email_id, user);
        });
      }
    }
  } catch (error) {
    logger.error("Error in loginWithPassword", { error: String(error) });
  }
  if (setGuardiansListAtom) {
    setGuardiansListAtom(guardiansMap);
  }
  return allGuardiansList;
};

export const sortCenterHeadsByName = (
  list: UserDetailsModel[],
): UserDetailsModel[] =>
  [...list].sort((a, b) => {
    if (a.first_name && b.first_name) {
      return a.first_name.localeCompare(b.first_name);
    }
    return 0;
  });

export const fetchAllCenterHeads = async (
  email: string,
  setCenterHeadsListAtom?: (value: Map<string, UserDetailsModel>) => void,
  sessionId?: string,
): Promise<UserDetailsModel[] | undefined> => {
  let allCenterHeadsList: UserDetailsModel[] = [];
  let centerHeadsMap = new Map<string, UserDetailsModel>();
  try {
    const response = await getAllUsersApi(
      AppConstants.Roles.CENTER_HEAD,
      email,
      sessionId,
    );
    if (response && response.data && response.status === HttpStatus.OK) {
      allCenterHeadsList = response.data as UserDetailsModel[];
      if (allCenterHeadsList && allCenterHeadsList.length > 0) {
        allCenterHeadsList.map((user: UserDetailsModel) => {
          centerHeadsMap.set(user.email_id, user);
        });
      }
    }
  } catch (error) {
    logger.error("Error in fetchAllCenterHeads", { error: String(error) });
  }
  if (setCenterHeadsListAtom) {
    setCenterHeadsListAtom(centerHeadsMap);
  }
  return allCenterHeadsList;
};

export const fetchTraineeList = async (
  email: string,
  role: string,
  sessionId?: string,
  setTraineesListAtom?: (value: Map<string, UserDetailsModel>) => void,
): Promise<UserDetailsModel[]> => {
  let traineesList: UserDetailsModel[] = [];
  let traineesMap = new Map<string, UserDetailsModel>();
  let response: ResponseFormatModel;
  try {
    if (role === AppConstants.Roles.GUARDIAN) {
      response = await getTraineesForGuardianApi(email, sessionId);
    } else {
      response = await getAllUsersApi(
        AppConstants.Roles.TRAINEE,
        email,
        sessionId,
      );
    }
    if (response && response.data && response.status === HttpStatus.OK) {
      traineesList = response.data as UserDetailsModel[];
      if (traineesList && traineesList.length > 0) {
        traineesList.map((user: UserDetailsModel) => {
          traineesMap.set(user.email_id, user);
        });
      }
    }
  } catch (error) {
    logger.error("Error in loginWithPassword", { error: String(error) });
  }
  if (setTraineesListAtom) {
    setTraineesListAtom(traineesMap);
  }
  return traineesList;
};

export const getUserDetailsByEmail = async (
  email: string,
): Promise<UserDetailsModel> => {
  try {
    const response = await getUserDetailsApi(email);
    if (response && response.data && response.status === HttpStatus.OK) {
      return response.data as UserDetailsModel;
    } else {
      throw new Error("Failed to fetch user details");
    }
  } catch (error) {
    logger.error("Error fetching user details:", { error: String(error) });
    throw error;
  }
};

/*export const getChatTimeOfSession = async (email_id: string, sessionDetails: ChatSessionsModel): Promise<string> => {
    try {
        const response = await getTimeForChat(email_id, sessionDetails);
        if (response && response.data && response.status === HttpStatus.OK) {
            return response.data as string;
        }
    } catch (error) {
        logger.error("Error fetching chat time:", { error: String(error) });
        throw error;
    }
    return "";
}*/
